import { render, staticRenderFns } from "./SrcFrame.vue?vue&type=template&id=243a94f0"
import script from "./SrcFrame.vue?vue&type=script&lang=js"
export * from "./SrcFrame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('243a94f0')) {
      api.createRecord('243a94f0', component.options)
    } else {
      api.reload('243a94f0', component.options)
    }
    module.hot.accept("./SrcFrame.vue?vue&type=template&id=243a94f0", function () {
      api.rerender('243a94f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Dialog/SrcFrame.vue"
export default component.exports